import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { LiviaService } from '../services/livia.service';

/** Accès à `/livia` : rôles autorisés RAG (aligné backend). */
@Injectable({ providedIn: 'root' })
export class LiviaGuard implements CanActivate {
  constructor(
    private readonly authService: AuthService,
    private readonly liviaService: LiviaService,
    private readonly router: Router
  ) {}

  canActivate(): boolean {
    if (!this.authService.isLoggedIn()) {
      this.router.navigate(['/auth/login']);
      return false;
    }

    const role = this.authService.getCurrentUser()?.role?.nom;
    if (this.liviaService.isRoleAllowed(role)) {
      return true;
    }

    this.router.navigate(['/auth/login']);
    return false;
  }
}
